// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { node, icon } from "~/util/dom";
import { registerUser } from "~/login";
import { _ } from "~/i18n";

export default class MyMapsLogin {
	constructor() {
		const { user } = store.getState().user;

		this._dom = {
			container: node("div", { className: "mymap-login" })
		};
		this._state = "normal";

		this._create(user);

		const w = watch(store.getState, "user", watchCurrentUser);
		this._storeUnsubscribe = store.subscribe(w(() => {
			this._loginState();
		}));
	}

	destroy() {
		this._storeUnsubscribe();
	}

	get container() {
		return this._dom.container;
	}

	rebuild(logout) {
		const { user } = store.getState().user;

		this._state = logout ? "logout" : "normal";
		this._create(user);
	}

	handleEvent(e) {
		if (e.target == this._dom.login) {
			Mapy.getComponent("login").open({
				analyticsData: {
					loginOrigin: "myMaps",
				},
				motivation: "none",
			});
		} else if (e.target == this._dom.register) {
			registerUser();
		} else if (this._dom.loginAs?.contains(e.target)) {
			const { user } = store.getState().user;

			Mapy.getComponent("login").open({
				username: user.accountDisplayName,
				analyticsData: {
					loginOrigin: "myMaps",
				},
				motivation: "none",
			});
		}
		else if (e.target == this._dom.forget) {
			Mapy.getComponent("login").logout(true).then(() => {
				this.rebuild(true);
			}, () => {});
		}
	}

	_loginState() {
		this.rebuild();
	}

	_create(user) {
		this._dom.container.innerHTML = "";

		if (user.state === "orange") {
			const h2 = node("h2", {}, _("mymap.login.logout.title"));
			const desc = node("p", { className: "logout-desc" }, _("mymap.login.logout.desc"));
			this._dom.container.appendChild(Mapy.getComponent("profile").container);
			this._dom.container.appendChild(h2);
			this._dom.container.appendChild(desc);
		} else {
			this._dom.container.classList.add("profile");

			let loginCont = node("div", { className: "user new" });
			let buttons = node("div", { className: "buttons" });
			let title = node("h2");

			title.innerHTML = _(`mymap.login.${this._state == "logout" ? `leaving` : `incoming`}.title`);

			if (this._state == "logout") {
				title.classList.add("logout");
			}

			loginCont.appendChild(title);

			buttons.classList.add("row");
			let login = node("button", { type: "button", className: "button login" }, _("mymap.login.login"));
			let register = node("button", { type: "button", className: "button" }, _("mymap.login.register"));

			login.dataset.logSection = "accounts";
			register.dataset.logSection = "accounts";

			buttons.appendChild(login);
			buttons.appendChild(register);

			login.addEventListener("click", this);
			register.addEventListener("click", this);

			this._dom.login = login;
			this._dom.register = register;

			loginCont.appendChild(buttons);

			let listIndexes = [
				_(`mymap.login.list.6`),
				_(`mymap.login.list.7`),
				_(`mymap.login.list.8`),
				_(`mymap.login.list.9`),
			];
			let listTitle = node("h3", {}, _("mymap.login.listTitle"));
			let list = node("ul");

			for (let i = 0; i < listIndexes.length; i++) {
				let item = node("li", {}, listIndexes[i]);
				item.firstChild.before(icon("star-line"));
				list.appendChild(item);
			}

			this._dom.container.appendChild(loginCont);
			this._dom.container.appendChild(listTitle);
			this._dom.container.appendChild(list);
		}

		this._dom.container.appendChild(node("img", { src: "/img/mymap/login.svg", width: "400", height: "295" }));
	}
}
